function userDetail(state = {}, action) {
  switch (action.type) {
    case 'CLEAR_USER_STATE':
      return {}
    case 'GET_USER_SUCCESS': {
      return action.payload
    }
    case 'EDIT_USER_SUCCESS': {
      return {
        ...state,
        ...action.payload.user,
      }
    }
    default:
      return state
  }
}

export default userDetail



// WEBPACK FOOTER //
// ./routes/admin/routes/users/reducer/userDetail.js